import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { genKey } from "../../../../../../helpers/keys.js";
import * as S from "./styled.js";
export const Points = ({ props , hover  })=>{
    const { items =[]  } = props ?? {};
    return /*#__PURE__*/ _jsx(S.Points, {
        children: items.map((item)=>/*#__PURE__*/ _jsx(React.Fragment, {
                children: item.items.map((i)=>/*#__PURE__*/ _jsx(S.Point, {
                        style: {
                            backgroundColor: i.id === hover ? 'Highlight' : ''
                        },
                        className: 'point' + i.id,
                        children: /*#__PURE__*/ _jsx(S.Link, {
                            href: i.href,
                            style: {
                                color: i.id === hover ? 'white' : ''
                            },
                            children: i.count
                        })
                    }, genKey(i.id)))
            }, genKey(item.title)))
    });
};
export default Points;

//# sourceMappingURL=index.js.map